import { FC } from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import styles from "./styles";

const Hero: FC = () => {
  return (
    <Box sx={[styles.wrapper, { mb: { xs: 3, lg: 6 } }]}>
      <Box sx={styles.overlay} />

      <Box
        component="video"
        src={`${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/lp/hero/heronew.mp4`}
        autoPlay
        loop
        muted
        playsInline
        width="auto"
        height="100%"
        sx={styles.video}
      />
      <Container>
        <Box
          sx={{
            zIndex: 1,
            position: "relative",
            width: "100%",
            height: "100%",
            left: 0,
          }}
        >
          <Box sx={styles.box}>
            <Typography variant="h1" sx={[styles.heading]}>
              Turn Your Product Into
              <br />
              <Box component="span" sx={styles.textHighlight}>
                Digital Experiences
              </Box>
            </Typography>
            <Typography
              variant="h2"
              sx={[styles.subtitle, { display: { xs: "none", md: "block" } }]}
            >
              We enable{" "}
              <Box component="span" sx={styles.textHighlight}>
                brands
              </Box>{" "}
              to blend{" "}
              <Box component="span" sx={styles.textHighlight}>
                physical and digital experiences
              </Box>
              ,<br />
              unlock new{" "}
              <Box component="span" sx={styles.textHighlight}>
                marketing tools
              </Box>
              , and extend{" "}
              <Box component="span" sx={styles.textHighlight}>
                customer engagement
              </Box>
              .
            </Typography>
            <Button
              variant="contained"
              size="large"
              sx={styles.button}
              endIcon={<ArrowForwardIcon />}
              href="/contact-us"
            >
              Get Started
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Hero;
